import { GETTING_LOCALES, GOT_LOCALES, LocaleActionTypes } from '@store/types';

import { locales as localesRequest } from '@services/locale';
import { ILocale } from '@models';

const gotLocales = (locales: ILocale[]) => ({
  type: GOT_LOCALES,
  payload: locales,
});

export const getLocales = (): any => {
  return (dispatch: (action: LocaleActionTypes) => void): any => {
    dispatch({ type: GETTING_LOCALES });

    localesRequest()
      .then((locales) => dispatch(gotLocales(locales)))
      .catch(() => {});
  };
};
